import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from './menu-item.interface';

@Component({
  selector: 'app-menu-item',
  template: `
    <ion-menu-toggle auto-hide="false">
      <ion-item button menuClose (click)="navigate(item, $event)" color="transparent">
        <ion-icon slot="start" [name]="item.icon.name" [color]="isActive(item)" *ngIf="item.icon.name"></ion-icon>
        <ion-icon slot="start" [src]="item.icon.src" [color]="isActive(item)" *ngIf="item.icon.src"></ion-icon>
        {{ item.title }}
      </ion-item>
    </ion-menu-toggle>`,
  styles: [],
})
export class MenuItemComponent {

  @Input() className: string = '';
  @Input() item: MenuItem = { title: '' }
  @Output() onItemClick = new EventEmitter();

  constructor(private router: Router) { }

  navigate(item: any, ev: Event) {
    this.onItemClick.emit({ ev, item })
  }

  isActive(item: any) {
    try {
      return this.router.url == item.url
    } catch (error) {
      return false;
    }
  }

}
